import type { CosmosDiagnostics } from '@/_contract/diagnostics';
import { DISABLED_DIAGNOSTICS } from '@/_pure/diagnostics';

let active: Readonly<CosmosDiagnostics> = DISABLED_DIAGNOSTICS;

/** Browser effect owners cannot consume React context; the committed route host publishes their policy. */
export function publishCosmosDiagnostics(options: Readonly<CosmosDiagnostics>): () => void {
    active = options;
    return () => {
        if (active === options) active = DISABLED_DIAGNOSTICS;
    };
}

export function readCosmosDiagnostics(): Readonly<CosmosDiagnostics> {
    return active;
}
